import toast from 'react-hot-toast';
import {
  initializeChatSession,
  sendMessage,
  closeChatSession,
} from '../../../sevices/chatSupport';

// Constants for success and error messages
const CHAT_SUCCESS_MESSAGES = {
  SESSION_INITIALIZED: 'Chat session started successfully!',
  MESSAGE_SENT: 'Message sent successfully!',
  SESSION_CLOSED: 'Chat session closed successfully!',
};

const CHAT_ERROR_MESSAGES = {
  SESSION_INIT_FAILED: 'Failed to start chat session. Please try again.',
  MESSAGE_SEND_FAILED: 'Failed to send message. Please try again.',
  SESSION_CLOSE_FAILED: 'Failed to close chat session. Please try again.',
};

/**
 * Hook for initializing a new chat session
 * Returns mutation object with mutateAsync function
 */
export const useInitializeChatSessionMutation = () => {
  const mutateAsync = async (userInfo) => {
    try {
      const response = await initializeChatSession(userInfo);
      if (response.success && response.data) {
        // Store session data in localStorage
        localStorage.setItem('chat_session_id', response.data.session_id);
        localStorage.setItem('chat_session_data', JSON.stringify(response.data));
        
        toast.success(CHAT_SUCCESS_MESSAGES.SESSION_INITIALIZED);
        return response;
      } else {
        toast.error(response.error || CHAT_ERROR_MESSAGES.SESSION_INIT_FAILED);
        throw new Error(response.error || CHAT_ERROR_MESSAGES.SESSION_INIT_FAILED);
      }
    } catch (error) {
      console.error('Initialize chat session error:', error);
      toast.error(CHAT_ERROR_MESSAGES.SESSION_INIT_FAILED);
      throw error;
    }
  };

  return {
    mutateAsync,
    isPending: false, // You can add state management here if needed
  };
};

/**
 * Hook for sending messages in a chat session
 * Returns mutation object with mutateAsync function
 */
export const useSendMessageMutation = () => {
  const mutateAsync = async ({ sessionId, messageData }) => {
    try {
      const response = await sendMessage(sessionId, messageData);
      if (response.success) {
        // toast.success(CHAT_SUCCESS_MESSAGES.MESSAGE_SENT);
        return response;
      } else {
        toast.error(response.error || CHAT_ERROR_MESSAGES.MESSAGE_SEND_FAILED);
        throw new Error(response.error || CHAT_ERROR_MESSAGES.MESSAGE_SEND_FAILED);
      }
    } catch (error) {
      console.error('Send message error:', error);
      toast.error(CHAT_ERROR_MESSAGES.MESSAGE_SEND_FAILED);
      throw error;
    }
  };

  return {
    mutateAsync,
    isPending: false, // You can add state management here if needed
  };
};

/**
 * Hook for closing a chat session
 * Returns mutation object with mutateAsync function
 */
export const useCloseChatSessionMutation = () => {
  const mutateAsync = async (sessionId) => {
    try {
      const response = await closeChatSession(sessionId);
      if (response.success) {
        toast.success(CHAT_SUCCESS_MESSAGES.SESSION_CLOSED);
        return response;
      } else {
        toast.error(response.error || CHAT_ERROR_MESSAGES.SESSION_CLOSE_FAILED);
        throw new Error(response.error || CHAT_ERROR_MESSAGES.SESSION_CLOSE_FAILED);
      }
    } catch (error) {
      console.error('Close chat session error:', error);
      toast.error(CHAT_ERROR_MESSAGES.SESSION_CLOSE_FAILED);
      throw error;
    }
  };

  return {
    mutateAsync,
    isPending: false, // You can add state management here if needed
  };
};
